import { Box, IconButton } from '@mui/material';
import { PaperPlaneRight, Stop, StopCircle } from '@phosphor-icons/react';
import React, { useEffect, useRef, useState } from 'react';
import WaveSurfer from 'wavesurfer.js';
import RecordPlugin from 'wavesurfer.js/dist/plugins/record';

interface WaveformVisualizerProps {
  isRecording: boolean;
  handleStopRecording: () => void;
  backgroundColor: string;
  waveColor: string;
}

export function WaveformVisualizer({
  isRecording,
  handleStopRecording,
  backgroundColor,
  waveColor,
}: Readonly<WaveformVisualizerProps>) {
  const waveContainerRef = useRef<HTMLDivElement | null>(null);
  const wavesurferRef = useRef<WaveSurfer | null>(null);
  const recordingRef = useRef<RecordPlugin | null>(null);

  useEffect(() => {
    if (!waveContainerRef.current) return;

    const wavesurfer = WaveSurfer.create({
      container: waveContainerRef.current,
      waveColor,
      interact: false,
      height: 'auto',
    });

    const record = wavesurfer.registerPlugin(
      RecordPlugin.create({
        renderRecordedAudio: false,
        scrollingWaveform: true,
        continuousWaveform: false,
      }),
    );

    wavesurferRef.current = wavesurfer;
    recordingRef.current = record;

    return () => {
      wavesurfer.destroy();
    };
  }, [waveColor]);

  useEffect(() => {
    if (isRecording) {
      recordingRef.current?.startMic();
    } else {
      recordingRef.current?.stopMic();
    }
  }, [isRecording]);

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        width: '100%',
        height: '48px',
        borderRadius: '8px',
        backgroundColor,
      }}
    >
      <IconButton onClick={handleStopRecording}>
        <StopCircle color="red" size={20} weight="regular" />
      </IconButton>

      <div
        style={{
          width: '100%',
          height: '100%',
        }}
        ref={waveContainerRef}
      />

      {/* <IconButton>
        <PaperPlaneRight color="green" size={20} weight="regular" />
      </IconButton> */}
    </Box>
  );
}
